import { c as _c } from "react/compiler-runtime";
import type { Flag } from '../../../types';
import { useFlag } from '../use-flag';
import css from './switch.module.scss';
interface Props {
  flag: Flag;
}
export function Switch(t0) {
  const $ = _c(9);
  const {
    flag
  } = t0;
  const {
    value,
    onChange
  } = useFlag(flag);
  const t1 = !!value;
  let t2;
  if ($[0] !== onChange) {
    t2 = e => onChange(e.target.checked);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== flag.id || $[3] !== t1 || $[4] !== t2) {
    t3 = <input id={flag.id} checked={t1} className={css.input} onChange={t2} type="checkbox" />;
    $[2] = flag.id;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={css.slider} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <label className={css.toggle}>{t3}{t4}</label>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}